import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Content } from '@/components/ui/content';
import { CopyText } from '@/components/ui/copy-text';
import { Form, FormContent } from '@/components/ui/form';
import { FormInput } from '@/components/ui/form-fields/form-input';
import { FormMultiSelect } from '@/components/ui/form-fields/form-multi-select';
import { FormSwitch } from '@/components/ui/form-fields/form-switch';
import type { Screen } from '@/db/schema';
import { meta } from '@/lib/meta';
import { useScreen } from '@/services/screens';
import { ScreenPreview } from '../+components/preview';

export const Route = createFileRoute('/_app/screens/$id/view')({
  head: () => meta({ label }),
  component: RouteComponent,
});

type Schema = Screen;
const model = 'screens';
const label = 'Tela';

const ACTION_OPTIONS = [
  { label: 'Listar (browse)', value: 'browse' },
  { label: 'Criar (create)', value: 'create' },
  { label: 'Visualizar (read)', value: 'read' },
  { label: 'Editar (update)', value: 'update' },
  { label: 'Excluir (delete)', value: 'delete' },
];

function RouteComponent() {
  const { id } = Route.useParams();
  const { data } = useScreen({ id });

  const form = useForm<Schema>({ disabled: true });

  useEffect(() => {
    if (data) form.reset(data);
  }, [data, form]);

  const shortId = id?.slice(0, 8);

  return (
    <Content
      breadcrumbs={{
        title: (
          <>
            {label} <CopyText className="ml-2" value={id} label={`${shortId}...`} />
          </>
        ),
        items: [
          { label: 'Listagem', route: `/${model}` },
          { label: 'Visualizar', active: true },
        ],
      }}
    >
      <Form id="form" title="Dados da tela" description="Configuração da tela.">
        <FormContent>
          <FormInput name="resource" control={form.control} label="Recurso (slug)" />
          <FormInput name="label" control={form.control} label="Label (singular)" />
          <FormInput name="pluralLabel" control={form.control} label="Label (plural)" />
          <FormInput name="icon" control={form.control} label="Ícone (lucide)" />
          <FormSwitch name="showInMenu" control={form.control} label="Mostrar no menu" />
          <FormSwitch name="isActive" control={form.control} label="Ativa" />
          <FormMultiSelect
            name="actions"
            control={form.control}
            label="Ações habilitadas"
            options={ACTION_OPTIONS}
            sm={12}
            md={12}
            lg={12}
          />
          <ScreenPreview control={form.control as any} />
        </FormContent>
      </Form>
    </Content>
  );
}
